module.exports = __webpack_public_path__ + "assets/img/chat-bottom-bg.c7caf97b.png";